import { PageSection } from 'Components/Layout';
import {
  WorksheetImagesAndRemarksSection,
  WorksheetRootComponent,
  WorksheetTestedBySection,
} from 'Components/Worksheets/Core';
import ids from 'Components/Worksheets/QestIds';
import { BsEnIsoLiquidLimitMethodBSection, BsEnIsoPlasticLimitSection, BsEnIsoPreparationSection } from './Sections';
import { BsEnIsoResultsSectionMethodB } from './Sections/Results';

const qestIds = [ids.atterbergLimit.BS_EN_ISO_17892_12_2018.rev2018_2022_methodB];

let BsEnIsoAtterbergLimitWorksheetMethodB: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection heading="Preparation">
        <BsEnIsoPreparationSection />
      </PageSection>
      <PageSection heading="Liquid Limit">
        <BsEnIsoLiquidLimitMethodBSection />
      </PageSection>
      <PageSection heading="Plastic Limit">
        <BsEnIsoPlasticLimitSection />
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <PageSection heading="Results">
        <BsEnIsoResultsSectionMethodB />
      </PageSection>
      <PageSection heading="Images and Remarks">
        <WorksheetImagesAndRemarksSection />
      </PageSection>
    </>
  );
};

BsEnIsoAtterbergLimitWorksheetMethodB.qestIds = qestIds;

export default BsEnIsoAtterbergLimitWorksheetMethodB;
